import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useReveal } from "../hooks/useReveal";
import FlyWords from "./FlyWords";
import { CITIES, CITY_LIST } from "../data/cities";

export default function ServiceArea() {
  const ref = useReveal();
  return (
    <section
      id="service-area"
      data-testid="service-area-section"
      className="section bg-[#050505] relative"
      ref={ref}
    >
      <div className="container-x text-center reveal">
        <div className="overline justify-center mb-5" style={{ display: "inline-flex" }}>
          Serving the Tampa Bay area
        </div>
        <h2 className="sr-only">Service area</h2>
        <FlyWords
          as="div"
          className="font-display text-4xl md:text-5xl lg:text-6xl text-white font-light leading-tight max-w-3xl mx-auto"
          segments={[
            { text: "Proudly building across" },
            { type: "break" },
            { text: "Florida\u2019s Gulf Coast.", className: "italic text-[#D4AF37]" },
          ]}
        />

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-3 gap-y-3 max-w-3xl mx-auto">
          {CITY_LIST.map((slug) => (
            <Link
              key={slug}
              to={`/locations/${slug}`}
              data-testid={`service-city-${slug}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#27272A] bg-[#111111] text-sm text-white hover:border-[#D4AF37] hover:text-[#F3E5AB] transition-colors"
            >
              <MapPin className="h-3.5 w-3.5 text-[#D4AF37]" />
              {CITIES[slug].name}
            </Link>
          ))}
          <Link
            to="/locations"
            data-testid="service-city-all"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/5 text-sm text-[#F3E5AB] hover:bg-[#D4AF37]/10 transition-colors"
          >
            All service areas <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>

        <p className="mt-10 text-[#A1A1AA] max-w-xl mx-auto text-base">
          Not sure if we cover your zip code?
          <a href="#contact" className="link-gold text-[#D4AF37] ml-2">
            Ask us directly →
          </a>
        </p>
      </div>
    </section>
  );
}
